export default "__VITE_ASSET__6ajw40vh__"